import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { KpiObjectType } from '@/api/entities/kpi';

const KPI_EVALUATION_URI = '/kpiEvaluation';

export const getKpiEvaluationByType = async (type: KpiObjectType) => {
  const params = new URLSearchParams();

  params.append('type', type);

  return requestApi({
    url: `${KPI_EVALUATION_URI}/byType?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
